export default defineNuxtPlugin((nuxtApp) => {
	function ctrlKey(event, key) {
		return event.ctrlKey && event.key == key
	}

	return {
		provide: {
			ctrlKey,
		},
	}
})
